import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { CourierEarningListResponse } from '../model/response/configuration-list.response';
import { DefaultResponseInterface } from '../model/response/default-response.interface';

@Injectable()
export class AdminRegistrationNoteApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public save(request) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/administration/registration-notes',
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public update(id, request) {
    return this.http.put<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/registration-notes/${id}`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public delete(id) {
    return this.http.delete<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/registration-notes/${id}`,
      {headers: this.getAuthHeaders()}
    );
  }
}
